import  klickartPerformantAccordion  from 'src/performant/accordion'

window.addEventListener('load', klickartPerformantAccordion);
